import { InstructionType, ModalBehaviorType } from "@/common/types";
import { FC, ReactNode } from "react";
import { CheckOnGreenICon, SpreedSheetIcon } from "../icon";
import Typography from "../Typography/Typography";
import { cn } from "@/common/utils";

interface ModalIconProps {
  behavior: ModalBehaviorType;
}

const ModalIcon: FC<ModalIconProps> = ({ behavior }) => {
  switch (behavior) {
    case "error":
      return (
        <div className="bg-red-light w-[90px] h-[90px] rounded-full mx-auto text-center flex items-center justify-center text-[78px] font-bold text-red-main">
          !
        </div>
      );
    case "success":
      return (
        <div className="w-[90px] h-[90px] mx-auto flex justify-start items-center">
          <CheckOnGreenICon width="90" height="90" />
        </div>
      );
    case "warning":
      return (
        <div className="w-[90px] h-[90px] mx-auto flex items-center justify-center rounded-full bg-yellow-main text-yellow-icon">
          <SpreedSheetIcon width="48" height="48" />
        </div>
      );
    default:
      break;
  }
};

export default function InfoModal({
  instruction,
  actions,
  desClassName,
}: {
  instruction: InstructionType;
  actions: ReactNode[];
  desClassName?: string;
}) {
  return (
    <div className="min-w-[400px]">
      <Typography
        type="p"
        fontFamily="font-kanit"
        fontWeight="font-medium"
        textAlign="center"
        customStyles="text-center"
      >
        {instruction.header}
      </Typography>
      <div className="flex flex-col gap-4 mt-8">
        <ModalIcon behavior={instruction.behavior} />
        <Typography
          type="p"
          fontFamily="font-kanit"
          fontWeight="font-light"
          textAlign="center"
          customStyles={cn("text-center", desClassName)}
        >
          {instruction.description}
        </Typography>
      </div>
      <div className="flex justify-between mt-4">{...actions}</div>
    </div>
  );
}
